import { render, staticRenderFns } from "./TherapyPayments.vue?vue&type=template&id=09bd699b"
import script from "./TherapyPayments.vue?vue&type=script&lang=js"
export * from "./TherapyPayments.vue?vue&type=script&lang=js"
import style0 from "./TherapyPayments.vue?vue&type=style&index=0&id=09bd699b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports